import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '@/layout/Header';
import { BottomNav } from '@/layout/BottomNav';
import { SideNav } from '@/layout/SideNav';
import { SearchPalette } from '@/components/SearchPalette';

export const AppLayout = () => {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  // Keyboard: '/' opens search palette on desktop.
  React.useEffect(() => {
    const handler = (e) => {
      if (e.key === '/' && document.activeElement?.tagName !== 'INPUT' && document.activeElement?.tagName !== 'TEXTAREA') {
        e.preventDefault();
        const ev = new CustomEvent('bb-open-search');
        window.dispatchEvent(ev);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SideNav />
      <Header />
      <main className="flex-1 pb-28 md:pb-16 transition-[padding] duration-200 md:[padding-left:var(--bb-sidenav-w,240px)]">
        <Outlet />
      </main>
      <BottomNav />
      <SearchPalette />
    </div>
  );
};
